import React, { FC } from 'react';
import { Cascader } from "antd";
import { CascaderProps } from 'antd/lib/cascader';

export type { CascaderProps };

const ProCascader: FC<CascaderProps<any>> = props => {
  return (
    <Cascader {...props} />
  );
}; 

export default ProCascader;
